import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Header } from 'semantic-ui-react';
import { sysAPI } from '../../../../apis/SysAPI';
import { responseError } from '../../../../helpers';
import { useDispatch } from 'react-redux';
import { StackedGraphic } from '../../Graphics/Tables';
import Loading from '../../../../components/globals/Loading';

const WeekUserAcvitityByArea = forwardRef(({ activeIndex, startDate, endDate, areas, loading, excludeCompanies, includeCompanies, setLoading }, ref) => {
    const dispatch = useDispatch();
    const [labels, setLables] = useState([]);
    const [datasets, setDataset] = useState([]);
    const [internalLoading, setIntenalLoading] = useState(false)

    const getData = async () => {
        setLoading(true);
        setIntenalLoading(true);
        try {
            const { data: response_3 } = await sysAPI.get(`/advisors/graphics/weekly-processes-by-area`, {
            params: {
              startDate: startDate,
              endDate: endDate,
              isPeriod: true,
              companies: includeCompanies.join(','),
              excludeCompanies: excludeCompanies.join(','),
            },
          });
          setDataset(response_3.datasets);
          setLables(response_3.labels);
        } catch (error) {
            responseError(error, undefined, 'WeekUserAcvitityByArea.getData', dispatch);
        }
        setLoading(false);
        setIntenalLoading(false);
    };

    useImperativeHandle(ref, () => ({
        getData: getData,
    }));

    useEffect(() => {
        getData();

        // eslint-disable-next-line
    }, [activeIndex]);

    const options = { barPercentage: 0.85 }
    const plugins = { legend: { display: true, position: 'right', labels: { font: { size: 15 } } } }
    const datalabels = { anchor: 'end', align: 'end', offset: 5 }
    return (
        <div className='card_metrics'>
            {internalLoading ? <>
                <Loading />
            </> : <>
                <Header textAlign="center" as="h3">
                    Week's User Activity by area
                </Header>
                <div>
                    <StackedGraphic
                        labels={labels}
                        datasets={datasets}
                        options={options}
                        plugins={plugins}
                        datalabels={datalabels}
                    />
                </div>
            </>}
        </div>
    );
});

export default WeekUserAcvitityByArea;
